(function () {
function openPanel(accordion, trigger, panel) {
    accordion.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');

    panel.hidden = false;

    // Animate height: from 0 -> scrollHeight
    panel.style.height = '0px';
    panel.style.transition = 'height 220ms ease';

    // Force reflow so the browser picks up height=0 before transitioning
    panel.offsetHeight;

    panel.style.height = panel.scrollHeight + 'px';

    // After animation, set height to auto so content changes don’t break layout
    panel.addEventListener('transitionend', function onEnd(e) {
    if (e.propertyName !== 'height') return;
    panel.style.height = 'auto';
    panel.style.transition = '';
    panel.removeEventListener('transitionend', onEnd);
    });
}

function closePanel(accordion, trigger, panel) {
    accordion.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');

    // Animate height: from current -> 0
    panel.style.height = panel.scrollHeight + 'px';
    panel.style.transition = 'height 220ms ease';
    panel.offsetHeight;

    panel.style.height = '0px';

    panel.addEventListener('transitionend', function onEnd(e) {
    if (e.propertyName !== 'height') return;
    panel.hidden = true;
    panel.style.height = '';
    panel.style.transition = '';
    panel.removeEventListener('transitionend', onEnd);
    });
}

document.querySelectorAll('[data-accordion]').forEach((accordion) => {
    const trigger = accordion.querySelector('.m-accordion__trigger');
    const panel = accordion.querySelector('.m-accordion__panel');

    if (!trigger || !panel) return;

    trigger.addEventListener('click', () => {
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    if (isOpen) closePanel(accordion, trigger, panel);
    else openPanel(accordion, trigger, panel);
    });
});
})();
